/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homecontributelink2Inputs */



/**
* | output |
* | --- |
* | "View the repository on GitHub" |
*
* @param {Homecontributelink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homecontributelink2 = /** @type {((inputs?: Homecontributelink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homecontributelink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("View the repository on GitHub")
	return /** @type {LocalizedString} */ ("Zum Repository auf GitHub")
});
export { homecontributelink2 as "homeContributeLink" }